/**
 * custom-alert.js
 * Funzione globale per mostrare alert/toast personalizzati
 * con Tailwind CSS usando il container esistente nel DOM
 */
(function () {
    const container = document.getElementById('customAlertContainer');

    if (!container) {
        console.error('customAlertContainer non trovato nel DOM. Assicurati che esista.');
        return;
    }

    /**
     * Mostra un toast personalizzato
     * @param {string} message - Testo del messaggio
     * @param {'success'|'error'} type - Tipo di messaggio
     * @param {number} duration - Durata in millisecondi
     */
    window.showCustomAlert = function (message, type = 'success', duration = 4000) {


        const alert = document.createElement('div');
        alert.className = `
            flex items-center gap-3 p-6 !important rounded-xl shadow-2xl transform transition-all
            duration-300 opacity-0 -translate-y-5 text-lg font-semibold
            text-black
            z-50
        `;

        const icon = document.createElement('span');
        icon.textContent = type === 'success' ? '✅' : '❌';
        alert.appendChild(icon);

        const text = document.createElement('span');
        text.textContent = message;
        alert.appendChild(text);

        container.appendChild(alert);

        // Animazione comparsa
        requestAnimationFrame(() => {
            alert.classList.remove('opacity-0', '-translate-y-5');
            alert.classList.add('opacity-100', 'translate-y-0');
        });

        setTimeout(() => {
            alert.classList.remove('opacity-100', 'translate-y-0');
            alert.classList.add('opacity-0', '-translate-y-5');
            setTimeout(() => {
                container.removeChild(alert);
            }, 300);
        }, duration);
    };
})();
